import React from 'react'
import { useTranslation } from 'react-i18next'

import Field from 'components/Shared/Fields'
import CampaignEditorInputFieldContainer from 'components/Shared/Permission/CampaignEditorInputFieldContainer'
import { fieldIdentifiers } from 'components/Shared/Comment'
import { RequirementCardContainer } from 'components/Shared/Fields/styles'
import FieldTitleAndSubTitle from 'components/Shared/Fields/FieldTitleAndSubTitle'

export enum GENDER_ENUM {
    MALE = 'male',
    FEMALE = 'female',
    OTHERS = 'others',
}

interface GenderRequirementProps {
    name: string
    onRemove: () => void
    requirementUuid?: string
    isReadOnly?: boolean
}

const GenderRequirement: React.FC<GenderRequirementProps> = ({ name, onRemove, requirementUuid, isReadOnly }) => {
    const [t] = useTranslation()

    const options = [
        {
            value: GENDER_ENUM.MALE,
            label: t('gender.male'),
        },
        {
            value: GENDER_ENUM.FEMALE,
            label: t('gender.female'),
        },
        {
            value: GENDER_ENUM.OTHERS,
            label: t('general.option.others'),
        },
    ]
    return (
        <RequirementCardContainer isCard>
            <FieldTitleAndSubTitle
                title={t('campaignEditor.requirement.genderHeader')}
                isRequired
                isReadOnly={isReadOnly}
                onClose={onRemove}
            />
            <CampaignEditorInputFieldContainer>
                <Field.RadioGroupField
                    title={t('campaignEditor.requirement.genderTitle')}
                    width="100%"
                    name={name}
                    options={options}
                    identifier={`${requirementUuid}_${fieldIdentifiers.gender}`}
                />
            </CampaignEditorInputFieldContainer>
        </RequirementCardContainer>
    )
}

export default GenderRequirement
